import { useEffect } from "react"
import { Grid, Text } from "@nextui-org/react"

import PagePath from "../../ui/pagePath"
import Header from "../../ui/header"
import GL_Opp_Now from '../../ui/resources/GL_opp_now.png'
import GL_Opp_Old from '../../ui/resources/GL_opp_old.png'
import GL_Opp_Upcoming from '../../ui/resources/GL_opp_upcoming.png'
import GL_Fund from '../../ui/resources/GL_fund.png'
import GL_Grant_Match from '../../ui/resources/GL_grant_match.png'
import { Content } from "../../ui/layout/content"
import { Box } from "../../ui/layout/box"
import GrantBox from "./grantBox"

export default () => {
    useEffect(() => {
        window.scrollTo(0,0)
    }, [])

    return (
        <>
            <PagePath paths={[
                {
                    value: "Home",
                    href: "/"
                },
                {
                    value: "Opportunities"
                }
            ]} />
            <Content spacerSize={2}>
                <Box css={{display: "flex", alignItems: "center", marginBottom: "10px"}}>
                    <img src={GL_Opp_Now} width="20px" style={{marginRight: "10px"}}/>
                    <Header h2 value="Current Opportunities"/> 
                </Box>
                <Box css={{mt: "$md"}}>
                    <Text size="$sm"  className="font-text">Currently, there's no grant opportunity available. Stay tuned!</Text>
                </Box>
            </Content>
            {/* <Content spacerSize={3}>
                <Box css={{display: "flex", alignItems: "center", marginBottom: "10px"}}>
                    <img src={GL_Opp_Upcoming} width="20px" style={{marginRight: "10px"}}/>
                    <Header h2 value="Upcoming Opportunities"/> 
                </Box>
                <Box css={{mt: "$md"}}>
                    <Text size="$sm"  className="font-text">We'll let you know as soon as they become available. Stay tuned!</Text>
                </Box>
            </Content> */}
            <Content spacerSize={3}>
                <Box css={{display: "flex", alignItems: "center", marginBottom: "10px"}}>
                    <img src={GL_Opp_Old} width="20px" style={{marginRight: "10px"}}/>
                    <Header h2 value="Previous Opportunities"/>
                </Box>
                <Grid.Container gap={2}>
                    <Grid xs={12} sm={4}>
                        <GrantBox
                            name="NSW Tech Vouchers (FY25)"
                            desc="Grant offered by NSW Government under the Boosting Business Innovation Program. Great for short-term projects solving well defined problems. Click Apply to learn more."
                            data={{
                                fund: {
                                    icon: GL_Fund,
                                    amount: `Up to ${new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', maximumSignificantDigits: 3 }).format(50000)}`
                                },
                                scheme: {
                                    icon: GL_Grant_Match,
                                    value: "1:1"
                                }
                            }}/>
                    </Grid>
                    <Grid xs={12} sm={4}>
                        <GrantBox
                            name="AEA Seed (1H FY25)"
                            desc="Grant offered by AEA for commercialising early university research. Great for early stage start-ups or founders looking to create initial product."
                            data={{
                                fund: {
                                    icon: GL_Fund,
                                    amount: `Up to ${new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', maximumSignificantDigits: 3 }).format(500000)}`
                                },
                                scheme: {
                                    icon: GL_Grant_Match,
                                    value: "10% $ + In-Kind"
                                }
                            }}/>
                    </Grid>
                    <Grid xs={12} sm={4}>
                        <GrantBox
                            name="AEA Ignite (1H FY25)"
                            desc="Grant offered by AEA for commercialising university research with TRL between 3 and 5. Great for companies looking to enhance existing product with new cutting-edge features."
                            data={{
                                fund: {
                                    icon: GL_Fund,
                                    amount: `Up to ${new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', maximumSignificantDigits: 3 }).format(1000000)}`
                                },
                                scheme: {
                                    icon: GL_Grant_Match,
                                    value: "10% $ + In-Kind"
                                }
                            }}/>
                    </Grid>
                    <Grid xs={12} sm={4}>
                        <GrantBox
                            name="AgTech/Livestock Tech Grant"
                            desc="* This grant is non-public. Please submit your EOI first."
                            data={{
                                fund: {
                                    icon: GL_Fund,
                                    amount: `Up to ${new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', maximumSignificantDigits: 3 }).format(200000)}`
                                },
                                scheme: {
                                    icon: GL_Grant_Match,
                                    value: "In-Kind"
                                }
                            }}/>
                    </Grid>
                </Grid.Container>
            </Content>
        </>
    )
}